// Automatically select API URL based on NODE_ENV
const getApiBaseUrl = () => {
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    if (isDevelopment) {
        return process.env.REACT_APP_API_BASE_URL_DEV;
    } else {
        return process.env.REACT_APP_API_BASE_URL_PROD;
    }
};

// Export the base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to construct API URLs
export const apiUrl = (path) => {
    return `${API_BASE_URL}${path}`;
};
